export default "__VITE_ASSET__Dt4_QQ_0__"